import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {rbacActions} from "../../config/rbac/actions.ts";
import {RestrictedRouteElement} from "../../components/RestrictedRouteElement.tsx";


export const ProductFeaturesLayout = () => {


    return (
        <Routes>
            <Route
                path='/'
                element={<RestrictedRouteElement rbacAction={rbacActions.ListProductFeatures}>
                    <IndexPage/></RestrictedRouteElement>}
            />
            <Route
                path='add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreateProductFeature}>
                    <AddPage/></RestrictedRouteElement>}
            />
            <Route
                path=':id'
                element={<RestrictedRouteElement rbacAction={rbacActions.GetProductFeature}>
                    <EditPage/></RestrictedRouteElement>}
            />

        </Routes>
    );
};
